// @flow

import Home from 'models/HomeOnBoarding';
import Asset from 'models/homes/Asset';

export const LIST_HOMES: 'list/homes' = 'list/homes';
export const DELETE_HOME: 'delete/home' = 'delete/home';
export const GET_HOME: 'get/home' = 'get/home';
export const GET_HOME_BY_ID: 'get/home/by/id' = 'get/home/by/id';
export const LIST_SIMILAR_HOMES: 'list/similar/homes' = 'list/similar/homes';
export const GET_PRICE_LIMITS: 'get/price/limits' = 'get/price/limits';
export const LIST_MOST_RECENT_HOMES: 'list/most/recent/homes' =
  'list/most/recent/homes';
export const CREATE_HOME_ONBOARDING: 'create/onboarding/home' =
  'create/onboarding/home';
export const UPDATE_HOME_ONBOARDING: 'update/onboarding/home' =
  'update/onboarding/home';
export const EDIT_HOME_ONBOARDING: 'edit/onboarding/home' =
  'edit/onboarding/home';
export const LIST_HOME_ASSETS: 'list/onboarding/home/assets' =
  'list/onboarding/home/assets';
export const UPLOAD_HOME_ASSET: 'upload/onboarding/home/asset' =
  'upload/onboarding/home/asset';
export const ADD_TEMP_HOME_ASSET: 'add/temp/home/asset' = 'add/temp/home/asset';
export const DELETE_HOME_ASSET: 'delete/onboarding/home/asset' =
  'delete/onboarding/home/asset';
export const LIST_ACCEPTED_ASSETS: 'list/accepted/assets' =
  'list/accepted/assets';
export const LIST_DECLINED_ASSETS: 'list/declined/assets' =
  'list/declined/assets';
export const CREATE_SIMILAR_HOME_ONBOARDING: 'create/similar/home/onboarding' =
  'create/similar/home/onboarding';
export const GET_HOMES_BY_USER: 'get/homes/by/user' = 'get/homes/by/user';
export const GET_HOME_HOME_MEETINGS: 'get/home/home_meetings' =
  'get/home/home_meetings';
export const SET_HOME_PAUSE: 'set/home/pause' = 'set/home/pause';
export const SET_HOME_PUBLISHED: 'set/home/published' = 'set/home/published';
export const LIST_BELONG_POSTS: 'list/belong/posts' = 'list/belong/posts';
export const GET_RECOMMENDED_PRICE: 'get/home/recommended_prices' =
  'get/home/recommended_prices';

export type Action =
  | {
      type: typeof LIST_HOMES,
      homes: [],
      pageSelector: number,
      metadata: {}
    }
  | {
      type: typeof GET_HOME,
      home: {}
    }
  | {
      type: typeof DELETE_HOME,
      home_id: string
    }
  | {
      type: typeof GET_HOME_BY_ID,
      home: {}
    }
  | {
      type: typeof GET_PRICE_LIMITS,
      home: {}
    }
  | {
      type: typeof LIST_SIMILAR_HOMES,
      homes: []
    }
  | {
      type: typeof LIST_MOST_RECENT_HOMES,
      homes: []
    }
  | {
      type: typeof CREATE_HOME_ONBOARDING,
      home: Home,
      metadata: {}
    }
  | {
      type: typeof EDIT_HOME_ONBOARDING,
      home: Home,
      metadata: {}
    }
  | {
      type: typeof UPDATE_HOME_ONBOARDING,
      home: Home,
      metadata: {}
    }
  | {
      type: typeof UPLOAD_HOME_ASSET,
      home: Home
    }
  | {
      type: typeof LIST_HOME_ASSETS,
      asset_type: string,
      assets: [],
      accepted: [],
      declined: []
    }
  | {
      type: typeof UPLOAD_HOME_ASSET,
      temp_asset_id: string,
      asset: Asset
    }
  | {
      type: typeof ADD_TEMP_HOME_ASSET,
      asset: Asset
    }
  | {
      type: typeof DELETE_HOME_ASSET,
      asset_id: string,
      asset_type: string
    }
  | {
      type: typeof CREATE_SIMILAR_HOME_ONBOARDING,
      home: Home,
      metadata: {}
    }
  | {
      type: typeof GET_HOMES_BY_USER,
      homes: [],
      metadata: {}
    }
  | {
      type: typeof GET_HOME_HOME_MEETINGS,
      home_meetings: []
    }
  | {
      type: typeof SET_HOME_PAUSE,
      home_id: string
    }
  | {
      type: typeof SET_HOME_PUBLISHED,
      home_id: string
    }
  | {
      type: typeof LIST_BELONG_POSTS,
      posts: []
    }
  | {
      type: typeof GET_RECOMMENDED_PRICE,
      recommended_price_feature: {}
    };
